!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.productForm = document.querySelector("product-form"), this.footer = document.querySelector("footer"), 
      this.isProductFormPassed = !1, this.isFooterVisible = !1;
    }
    connectedCallback() {
      this.productForm && this.initProductFormObserver(), this.footer && this.initFooterObserver(), 
      this.initChatBubbleObserver();
    }
    disconnectedCallback() {
      this.productFormObserver && this.productFormObserver.disconnect(), this.footerObserver && this.footerObserver.disconnect(), 
      this.chatBubbleObserver && this.chatBubbleObserver.disconnect();
    }
    initProductFormObserver() {
      this.productFormObserver = new IntersectionObserver((t => {
        t.forEach((t => {
          const {isIntersecting: e, boundingClientRect: r} = t;
          this.isProductFormPassed = !e && r.y < 0, this.updateStickyCartVisibility();
        }));
      }), {
        rootMargin: "0px"
      }), this.productFormObserver.observe(this.productForm);
    }
    initFooterObserver() {
      this.footerObserver = new IntersectionObserver((t => {
        t.forEach((t => {
          this.isFooterVisible = t.isIntersecting, this.updateStickyCartVisibility();
        }));
      }), {
        rootMargin: "0px"
      }), this.footerObserver.observe(this.footer);
    }
    initChatBubbleObserver() {
      this.chatBubbleObserver = new MutationObserver((t => {
        t.forEach((t => {
          t.addedNodes.forEach((t => {
            if (t.nodeType === Node.ELEMENT_NODE) {
              ("fc_frame" === t.id ? t : t.querySelector("#fc_frame")) && this.updateStickyCartVisibility();
            }
          })), "attributes" === t.type && "fc_frame" === t.target.id && setTimeout((() => {
            this.updateStickyCartVisibility();
          }), 100);
        }));
      })), this.chatBubbleObserver.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: [ "class", "style" ]
      });
    }
    updateStickyCartVisibility() {
      const t = this.isProductFormPassed && !this.isFooterVisible, e = document.querySelector("#fc_frame, #fc_frame.fc-widget-small");
      if (this.classList.toggle("opacity-0", !t), this.classList.toggle("pointer-events-none", !t), 
      e) if (t) {
        const t = `${this.offsetHeight + 15}px`;
        e.style.setProperty("bottom", t, "important");
      } else e.style.setProperty("bottom", "15px", "important");
    }
  }
  customElements.get("sticky-add-to-cart") || customElements.define("sticky-add-to-cart", t);
}();